<template>
  <b-col class="animated fadeIn">
    <b-card>
      <div slot="header">
        <div>
          <b-col>
            <b-row>
              <b-col sm="6">
                <i class="fa fa-bars"></i> {{$t('str.forum-mention-report')}}
              </b-col>
              <b-col sm="6"></b-col>
            </b-row>
          </b-col>
        </div>

        <div>
          <b-col sm="12" style="margin-top:10px;">
            <b-row>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.date-range') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <flat-pickr :config="mentionDateConfig" v-model="mentionDateRange" id="date_range" class="form-control"
                      name="date_range"></flat-pickr>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.country') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-select id="country_id" name="country_id" :plain="true" v-model="mentionCountryId"
                      style="height:100%;" :key="mentionCountrySelectKey">
                      <option value="">{{$t('str.all')}}</option>
                      <option v-for="(c, index) in mentionCountrySelect" :value="c.value" :key="index">{{c.text}}</option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="4">
                <b-row>
                  <b-col>
                    {{ $t('str.keyword') }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="mentionKeyword" @keyup.enter="getMentionData()">
                      </b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-row>
                  <b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">{{$t('str.office')}}</template>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-form-select id="office_id" name="office_id" :plain="true" v-model="mentionOfficeId"
                        style="height:100%;" @change="() => {
                          getMentionCountrySelect()
                          rerenderMentionCountrySelect()
                        }">
                        <option value="">{{$t('str.all')}}</option>
                        <option v-for="(c, index) in mentionOfficeSelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </template>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="6">
                <b-row>
                </b-row>
                <b-row style="height:100%">
                  <b-col style="display:flex; align-items:end; justify-content:flex-end;">
                    <b-button type="button" variant="secondary"
                      @click="resetMentionFilter()" class="mr-1">{{ $t('str.reset-filter') }}</b-button>
                    <b-button type="submit" variant="primary"
                      @click="getMentionData()">{{ $t('str.search') }}</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </div>

      <div>
        <b-col>
          <p :class="{ 'text-center': true, 'd-none': mentionData.length }" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{ 'd-none': !mentionData.length }" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="mentionData" :fields="fields" :current-page="currentPage">
          </b-table>
          <nav :class="{ 'd-none': !mentionData.length }">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-col>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'ForumProductMention',
  components: {
    'paging': Pagination,
    'buttons': Buttons,
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      mentionData: [],
      fields: [
        { key: 'no', label: 'No.' },
        { key: 'product_number', label: 'Product Number', sortable: true },
        { key: 'mention', label: 'Mention Count', sortable: true },
      ],
      currentPage: 1,
      totalPage: 0,
      mentionKeyword: '',
      mentionCountrySelect: [],
      mentionOfficeSelect: [],
      mentionCountryId: '',
      mentionOfficeId: '',
      mentionDateRange: (moment().subtract(1, 'months').format('YYYY-MM-DD'))+' - '+(moment().format('YYYY-MM-DD')),
      mentionDateConfig: {
        locale: {rangeSeparator: ' - '},
        mode: 'range',
        altInput: true,
        altFormat: 'd M Y',
        dateFormat: 'Y-m-d',
        defaultDate: [(moment().subtract(1, 'months').format('YYYY-MM-DD')), (moment().format('YYYY-MM-DD'))]
      },
      mentionCountrySelectKey: 0,
    }
  },
  methods: {
    async getMentionCountrySelect() {
      this.$auth.checkSession()
      try {
        let trail = ''
        if (this.mentionOfficeId != '') {
          trail += `?office=${this.mentionOfficeId}`
        }

        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Country/ByUserOfficeSelect${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        this.mentionCountrySelect = []
        for (let i = 0; i < cData.length; i++) {
          this.mentionCountrySelect.push({'value': cData[i].id, 'text': cData[i].name})
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getMentionOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        this.mentionOfficeSelect = []
        for (let i = 0; i < cData.length; i++) {
          this.mentionOfficeSelect.push({'value': cData[i].id, 'text': cData[i].name})
        }
      } catch (e) {
        console.log(e.response)
      }
    },
    async getMentionData() {
      this.$auth.checkSession()

      let officerOffice = this.$auth.session.get('office')
      if (officerOffice) this.mentionOfficeId = officerOffice

      let dates = this.mentionDateRange.split(' - ')

      let trail = `?start_date=${dates[0]}&end_date=${dates[1]}`
      if (this.mentionCountryId != '') trail += `&country=${this.mentionCountryId}`
      if (this.mentionOfficeId != '') trail += `&office=${this.mentionOfficeId}`
      if (this.mentionKeyword != '') trail += `&keyword=${this.mentionKeyword}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Report/ForumProductMention${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.mentionData = getData.data.data
      } catch (e) {
        console.log(e.response)
      }
    },
    resetMentionFilter() {
      this.mentionCountryId = ''
      this.mentionOfficeId = ''
      this.mentionDateRange = (moment().subtract(1, 'months').format('YYYY-MM-DD'))+' - '+(moment().format('YYYY-MM-DD'))
      this.getMentionCountrySelect()
      this.getMentionOfficeSelect()
      this.getMentionData()
    },
    rerenderMentionCountrySelect() {
      this.mentionCountrySelectKey += 1
      this.mentionCountryId = ''
    },
  },
  created() {
    this.getMentionCountrySelect()
    this.getMentionOfficeSelect()
    this.getMentionData()
  }
}
</script>